import { mount } from "@vue/test-utils";
import CustomSelect from "@/components/core/custom/CustomSelect";

jest.mock("@/components/core/custom/CustomSelect", () => ({
  default: {}
}));

describe("CustomSelect test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(CustomSelect);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component CustomSelect", () => {
    expect(wrapper).toBeDefined();
  });
});
